import { $t } from "../../../utils/intl";
import { handleNumberField } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { PercentFieldControl } from "../percent/PercentFieldControl/PercentFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";
import type { TextFieldValue } from "../text/text.config";

export const percentCompleteFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "progress",
  control: (props) => (
    <PercentFieldControl {...props} placeholder={$t(fieldsText.percentPlaceholder)} type="number" />
  ),
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
